export default __webpack_public_path__ + "static/media/handguard-panel.92307c10.svg";